export const FETCH_EVENTS = "@GOOGLE_CALENDAR/FETCH_EVENTS";
export const PUT_EVENTS = "@GOOGLE_CALENDAR/PUT_EVENTS"
export const SAVE_EVENT = '@GOOGLE_CALENDAR/SAVE_EVENT';
export const CREATE_EVENT = "@GOOGLE_CALENDAR/CREATE_EVENT";

export const actionCreators = {
    fetchEventsGoogleCalendar: () => ({ type: FETCH_EVENTS}),
    putEventsGoogleCalendar: (props) =>({ type: PUT_EVENTS, payload: props}),
    saveEventGoogleCalendar: (props) =>({ type: SAVE_EVENT, payload: props}),
    createEventGoogleCalendar: (props) =>({ type: CREATE_EVENT, payload: props})
}
